/**
 * ProductDescriptionBox autohandler.
 *
 * Usage:
 *
 *  data-sw-product-description-box=<productSpin>
 */

var $ = require('./../sw-jquery');
var ProductDescriptionBox = require('./../../lib/views/ProductDescriptionBox');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-product-description-box]').each(function() {
    var $el = $(this);

    require(['js/lib/models/ModelManager'], function(ModelManager) {

      var spin = $el.data('swProductDescriptionBox');

      var product = ModelManager.getProduct(spin);

      new ProductDescriptionBox({
        el: $el,
        model: product
      });

    });
  });

};
